import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./styles.module.css";
function ReviewItem({ review, isStarterKit }) {
    return (_jsxs("div", { className: `${styles.item} ${isStarterKit ? styles.starterKit : ""}`, children: [_jsx("div", { className: `${isStarterKit ? styles.boldHeader : styles.reviewheader}`, children: review.title }), _jsx("div", { className: styles.text, children: review.copy }), _jsx("div", { className: styles.username, children: `-${review.reviewer_name}` })] }));
}
export default ReviewItem;
